"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nav = require("@alicd/next/lib/nav");

var _nav2 = _interopRequireDefault(_nav);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_React$Component) {
    (0, _inherits3.default)(Item, _React$Component);

    function Item(props) {
        (0, _classCallCheck3.default)(this, Item);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

        _this.handle = null;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Item, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.handle = this.context.cruiAnchorDoRegister(this.props.index, this.props.to);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.handle && this.context.cruiAnchorDoUnregister(this.handle);
        }
    }, {
        key: "getContainer",
        value: function getContainer() {
            if (this.props.container) {
                return (0, _util.getNode)(this.props.container);
            } else {
                return this.context.cruiAnchorContainer;
            }
        }
    }, {
        key: "handleClick",
        value: function handleClick() {
            this.context.cruiAnchorDoScrollTo((0, _util.getNode)(this.props.to), this.getContainer(), { animation: this.context.cruiAnchorAnimation });
            typeof this.props.onClick === "function" && this.props.onClick();
        }
    }, {
        key: "render",
        value: function render() {
            var other = (0, _objectWithoutProperties3.default)(this.props, []);

            return _react2.default.createElement(_nav2.default.Item, (0, _extends3.default)({}, other, { onClick: this.handleClick }));
        }
    }]);
    return Item;
}(_react2.default.Component);

Item.propTypes = {
    // to: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.element]),
    container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node]),
    onClick: _propTypes2.default.func
};
Item.contextTypes = {
    cruiAnchorContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
    cruiAnchorAnimation: _propTypes2.default.bool,
    cruiAnchorDoRegister: _propTypes2.default.func,
    cruiAnchorDoUnregister: _propTypes2.default.func,
    cruiAnchorDoScrollTo: _propTypes2.default.func
};
exports.default = Item;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-anchor@0.0.6@@alicd/crui-anchor/lib/Item.js
// module id = 591
// module chunks = 0